import { throttle } from "lodash";
import { useEffect } from "react";

/**
 * IOSViewportFix is oddly enough used to fix the height of the viewport
 * on iOS to be the visible space and not include the toolbar.
 * This combined with the changes to tailwind.config.ts allows us use h-screen
 * without having to worry about other workarounds.
 */
const IOSViewportFix = () => {
  useEffect(() => {
    const update = throttle(() => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }, 20);
    if (typeof window !== "undefined") {
      window.addEventListener("resize", update);
      update();
    }
    return () => {
      window.removeEventListener("resize", update);
    };
  }, []);
  return null;
};

export default IOSViewportFix;
